import { Component } from "react";
import styles from "../constants/Styles";
import AppLogger from "../utils/AppLogger";
import { LocationMatch, LocationHistory } from "../utils/NavUtils";
import { Link as PostLink } from "../utils/PostInternals";
import { LinkArticle } from "./links/LinkArticle";
import { Spinner, View } from "./ui";

export interface EulaProps {
  match: LocationMatch;
  history: LocationHistory;
}

export interface EulaState {
  loading: boolean;

  links: PostLink[];
  lastError: any;
}

export class Eula extends Component<EulaProps, EulaState> {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,

      links: [],
      lastError: null
    };
  }

  async componentDidMount() {
    try {
      const links = (await this.listEulaLinks()) || [];

      this.setState({ links, loading: false });
    } catch (err) {
      AppLogger.error(`Error in links ${err}`, null);
      this.setState({ loading: false });
    }
  }
  async listEulaLinks() {
    try {
      const eula = await fetch(`firstpage/eula.json`).then(r => r.json());

      return [eula] as PostLink[];
    } catch (err) {
      AppLogger.error(`Error in listFirstPageLinks ${err}`);
    }
  }

  render() {
    const { loading, links } = this.state;
    const { history, match } = this.props;

    const containerStyle = {
      position: "relative",
      display:"flex",
      width: "90%%",
      justifyContent: "center",
      textAlign: "center"
    };

    if (loading) {
      return <Spinner  style={containerStyle} />;
    }

    return (
      <View key="eula" style={{ margin: styles.margin, paddingTop:50 }}>
        <LinkArticle
          activeLink={links[0]}
          history={history}
          match={match}
        />
      </View>
    );
  }
}
